import * as React from 'react';
import { ColumnProvider } from 'owa-calendar-surface-dategrid';
import { observer } from 'mobx-react';
import TimeMarkerBaseBehavior from './TimeMarkerBaseBehavior';

const styles = require('./TimeMarker.scss');

/**
 * Component that shows a line in the position of the current time on the calendar day and week views
 */
/* tslint:disable:use-mobx-react-lite-with-hooks
 * Using mobx-react-lite with functional components breaks the Calendar "behavior" architecture.
 * WI:47082 tracks refactoring this architecture.
 */
export default observer(function TimeMarkerBehavior({
    columnProvider,
}: {
    columnProvider: ColumnProvider;
}) {
    return (
        <TimeMarkerBaseBehavior
            columnProvider={columnProvider}
            className={styles.currentTimeWrapper}
            prefaceClassName={styles.currentTimePreface}
            markerClassName={styles.currentTimeMarker}
        />
    );
});
